<template>
  <div class="tabs is-large is-main" v-if="!isLoading">
    <ul>
      <router-link v-for="product in products" tag="li"
        :to="{ name: 'manual', params: { product: product.slug } }" :key="product.slug">
        <router-link :to="{ name: 'manual', params: { product: product.slug } }">
          {{ product.name }}
        </router-link>
      </router-link>
    </ul>
  </div>
  <loading-content v-else size="is-medium" text="" />
</template>

<script>
import API from '@/api'
import LoadingContent from './LoadingContent'

export default {
  name: 'ProductTabs',
  components: { LoadingContent },
  data () {
    return {
      isLoading: true,
      products: []
    }
  },
  mounted () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.isLoading = true
      API.products.index({
        take: -1,
        order_by: 'name'
      }, products => {
        this.products = products
        this.isLoading = false
      })
    }
  }
}
</script>
